/* eslint-disable */
import React from "react";
import {Button, Form, Input, message} from "antd";
import {useNavigate} from "react-router-dom";
import {md5} from "js-md5";
import {getUserApi, setNamePassword} from "../../../api/Api";
import {useAuth} from "../../../providers/AuthProvider";

function CompleteInfo() {

	const navigate = useNavigate();
	const userdetail = useAuth();
	const user = userdetail?.userInfo;
	const handleSubmit = async (values: any) => {
		try {
			const res: any = await setNamePassword({
				userId: user?.userId,
				name: values?.name,
				password: md5(values?.password),
			});
			if (res) {
				message.success("update information successful.");
				await getUserData();
				navigate("/d5data");
			}
		} catch (e: any) {
			message.error("Account login failed.");
			console.log(e);
		}
	};
	const getUserData = async () => {
		getUserApi()
			.then((res: object) => {
				localStorage.setItem("user", JSON.stringify(res));
			})
			.catch((e: Error) => {
				// toast.error("Failed to get user info");
				console.log(e);
			});
	};
	return (
		<div>
			<h1>请完善你的信息</h1>
			<Form
				name="basic"
				layout="vertical"
				initialValues={{remember: true}}
				onFinish={handleSubmit}
				onFinishFailed={() => {
				}}
				autoComplete="off"
			>
				<Form.Item
					label="用户名"
					name="name"
					rules={[
						{required: true, message: "Please input your username!"},
					]}
				>
					<Input style={{height: "40px", width: "95%"}}/>
				</Form.Item>

				<Form.Item
					label="密码"
					name="password"
					rules={[
						{required: true, message: "Please input your password!"},
					]}
					style={{marginBottom: "10px"}}
				>
					<Input.Password style={{height: "40px", width: "95%"}}/>
				</Form.Item>

				<Form.Item style={{textAlign: "center", marginTop: 30}}>
					<div style={{display: "flex", justifyContent: "center", gap: "20px"}}>
						<Button type="primary" htmlType="submit" className="submit-btn">
							确认
						</Button>
						<Button type="primary" htmlType="button" className="submit-btn" onClick={() => {
							navigate("/d5data")
						}}>
							跳过
						</Button>
					</div>
				</Form.Item>
			</Form>
		</div>
	);
}

export default CompleteInfo;
